import mitt from 'mitt';
import { StoreInfo } from 'services/api/dashboard';
import { Host } from 'services/api/leyanBotHost';
import { RelatedInfo } from 'views/Conversation/Sider/ToDoBundle/state';

export type EventBusEvents = {
  CONV_OPEN_SIDE_ORDER_DETAIL: Conversation.Trade.TradeWithLogistics;
  CANCEL_SEND_MESSAGE: Conversation.Message;
  HOST_VALUE_CHANGE: string;
  HOST_LIST_CHANGE: Host[];
  SCROLL_TO_MSG: string;
  ON_SEND_MESSAGE: void;
  UPDATE_DRAFT: string;
  CASE_UPDATED: undefined;
  OPEN_AGENT_FEEDBACK: undefined;
  GPT_GENERATOR_TRANS: General.Language;
  RELATED_MSGID_OPEN_TODO: RelatedInfo;
  UPDATE_DRAFT_CALLBACK: void;
  MESSAGE_EDITOR_FOCUS: void;
  // 退单表需要进行同步的ID
  RETURN_LIST_ID_SYNC: string[];
  TODO_UPDATE: string;
  SIDER_TODO_LOCATE: Todo.TodoInstance;
  CONV_LIST_FILTER_CLEAR: void;
  SCROLL_TO_MSG_BY_ID: string;
  SHOW_SYSTEM_MODAL: { activeKey?: string; activeFeature?: string };
  SHOW_FEEDBACK_MODAL: Feedback.CaseBasicInfo['caseId'] | undefined;
  CLEAR_QAPAIR_COUNTDOWN_TIMER: void;
  /** 确认是否存在关联知识库弹窗 */
  CONFIRM_QAPAIR_MODAL_EXISTS: { visible: boolean; msg: string };
  /** 重新获取 QAPair 回复 */
  QAPAIR_REPLY_REFETCH: string;
  HIGHLIGHT_CURRENT_QAPAIR_KNOWLEDGE: void;
  CITE_KNOWLEDGE_SCROLL: number | undefined;
  QAPAIR_RECORD_REFETCH: string;
  QAPAIR_CONV_KNOWLEDGE_QUERY_REFETCH: string;
  QAPAIR_KNOWLEDGE_SEARCH_SAME_ITEM: SupplementKnowledge.FilterSPU;
  CHECK_STORE_PLATFORM_CSAT_DETAIL: StoreInfo;
  MERCADO_QA_EVENT: 'refresh' | 'active' | 'hide';
  LOAD_MORE_MESSAGE: void;
};

export const eventBus = mitt<EventBusEvents>();
